export default {
      id: "file-color-usage",
      viewBox: "0 0 8.467 8.467",
      url: __webpack_public_path__ + "img/icons.svg#file-color",
      toString: function () {
        return this.url;
      }
    }